import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  HazardTable,
} from './DocumentPage';

const LoneWorkingDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Lone Working (Pyrolysis / Shot Blasting) – Risk Assessment"
    documentHeading="Risk Assessment 12: Lone Working within the Pyrolysis Building and Shot Blasting Booth"
    meta={[
      ['Document Reference', 'PVS-RA-12'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Area / Location', 'Pyrolysis Building / Shot Blasting Booth'],
      ['Activity', 'Lone Working in the Pyrolysis Building / Shot Blasting Booth'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Lone Working (Pyrolysis / Shot Blasting) – Risk Assessment',
      documentReference: 'PVS-RA-12',
      processActivity: 'Lone Working in the Pyrolysis Building / Shot Blasting Booth',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Scope">
      <Paragraph>
        This assessment covers the risks of persons working alone within the Pyrolysis Building and
        Shot Blasting Booth at Pressure Vessel Services Limited.
      </Paragraph>
    </Section>

    <Section number="2" title="Hazard Identification and Risk Assessment">
      <HazardTable
        columns={['Hazard', 'Control Measures Already in Place', 'Additional Control Measures Required']}
        rows={[
          [
            [
              'Risk of a person being injured or becoming unwell whilst lone working and not being able to summon help.',
              'Risk of working out of sight within the shot blasting booth with no immediate means of summoning assistance in the event of an emergency.',
            ],
            [
              'CCTV covers the Pyrolysis building with a live feed being shown on screens within the farmhouse office.',
              'Workers have access to mobile phones by which they can summon assistance.',
            ],
            [
              'Introduce a procedure whereby if lone working is taking place within the Pyrolysis building, a regular (30 min interval maximum) physical check is made on the person.',
              'Prohibit persons from working in the shot blasting booth if a second person is not present within the building.',
            ],
          ],
        ]}
      />
    </Section>

    <Section number="3" title="Reminder">
      <Paragraph className="font-semibold">
        You have a duty not only to protect your own health and safety but also to ensure that your
        actions do not put others around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default LoneWorkingDoc;
